/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface SavedViewDetail
 */
export interface SavedViewDetail {
  /**
   *
   * @type {string}
   * @memberof SavedViewDetail
   */
  savedViewId: string;
  /**
   *
   * @type {string}
   * @memberof SavedViewDetail
   */
  viewType: string;
  /**
   *
   * @type {string}
   * @memberof SavedViewDetail
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof SavedViewDetail
   */
  description?: string | null;
  /**
   *
   * @type {string}
   * @memberof SavedViewDetail
   */
  ownerEmail: string;
  /**
   *
   * @type {boolean}
   * @memberof SavedViewDetail
   */
  isOwner: boolean;
  /**
   *
   * @type {boolean}
   * @memberof SavedViewDetail
   */
  isFollowing: boolean;
  /**
   *
   * @type {Array<string>}
   * @memberof SavedViewDetail
   */
  followers: Array<string>;
  /**
   *
   * @type {string}
   * @memberof SavedViewDetail
   */
  columnConfig: string;
  /**
   *
   * @type {string}
   * @memberof SavedViewDetail
   */
  filters: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof SavedViewDetail
   */
  createdAt: OffsetDateTime;
}

/**
 * Check if a given object implements the SavedViewDetail interface.
 */
export function instanceOfSavedViewDetail(
  value: object,
): value is SavedViewDetail {
  if (!("savedViewId" in value) || value["savedViewId"] === undefined)
    return false;
  if (!("viewType" in value) || value["viewType"] === undefined) return false;
  if (!("name" in value) || value["name"] === undefined) return false;
  if (!("ownerEmail" in value) || value["ownerEmail"] === undefined)
    return false;
  if (!("isOwner" in value) || value["isOwner"] === undefined) return false;
  if (!("isFollowing" in value) || value["isFollowing"] === undefined)
    return false;
  if (!("followers" in value) || value["followers"] === undefined) return false;
  if (!("columnConfig" in value) || value["columnConfig"] === undefined)
    return false;
  if (!("filters" in value) || value["filters"] === undefined) return false;
  if (!("createdAt" in value) || value["createdAt"] === undefined) return false;
  return true;
}

export function SavedViewDetailFromJSON(json: any): SavedViewDetail {
  return SavedViewDetailFromJSONTyped(json, false);
}

export function SavedViewDetailFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SavedViewDetail {
  if (json == null) {
    return json;
  }
  return {
    savedViewId: json["savedViewId"],
    viewType: json["viewType"],
    name: json["name"],
    description: json["description"] == null ? undefined : json["description"],
    ownerEmail: json["ownerEmail"],
    isOwner: json["isOwner"],
    isFollowing: json["isFollowing"],
    followers: json["followers"],
    columnConfig: json["columnConfig"],
    filters: json["filters"],
    createdAt: json["createdAt"],
  };
}

export function SavedViewDetailToJSON(json: any): SavedViewDetail {
  return SavedViewDetailToJSONTyped(json, false);
}

export function SavedViewDetailToJSONTyped(
  value?: SavedViewDetail | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    savedViewId: value["savedViewId"],
    viewType: value["viewType"],
    name: value["name"],
    description: value["description"],
    ownerEmail: value["ownerEmail"],
    isOwner: value["isOwner"],
    isFollowing: value["isFollowing"],
    followers: value["followers"],
    columnConfig: value["columnConfig"],
    filters: value["filters"],
    createdAt: value["createdAt"],
  };
}
